module.exports = {
	"id": "SB",
	"name": "Solomon Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.285129,
			"9": null,
			"10": null,
			"11": 0.038992,
			"12": 0.002437,
			"13": 0.009748,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.004874,
			"20": null,
			"21": 0.034118,
			"22": 0.014622,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.17059,
			"32": 0.007311,
			"33": 0.004874,
			"34": 0.007311,
			"35": null,
			"36": 0.002437,
			"37": null,
			"38": 0.009748,
			"39": 0.004874,
			"40": 0.007311,
			"41": 0.004874,
			"42": 0.007311,
			"43": 0.012185,
			"44": 0.004874,
			"45": 0.014622,
			"46": 0.014622,
			"47": 0.009748,
			"48": null,
			"49": 1.284299,
			"50": 0.112102,
			"51": 0.165716,
			"52": 0.04874,
			"53": 4.637611,
			"54": 1.057658,
			"55": 0.070673,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.095043,
			"4": 0.009748,
			"5": 0.007311,
			"6": 0.02437,
			"7": 0.004874,
			"8": null,
			"9": null,
			"10": 0.007311,
			"11": null,
			"12": 0.007311,
			"13": 0.007311,
			"14": null,
			"15": 0.02437,
			"16": 0.034118,
			"17": 0.007311,
			"18": 0.004874,
			"19": 0.012185,
			"20": null,
			"21": 0.009748,
			"22": 0.009748,
			"23": 0.134035,
			"24": 0.004874,
			"25": 0.002437,
			"26": 0.004874,
			"27": 0.063362,
			"28": 0.009748,
			"29": 0.02437,
			"30": 0.002437,
			"31": 0.002437,
			"32": 0.004874,
			"33": 0.007311,
			"34": null,
			"35": 0.014622,
			"36": null,
			"37": 0.02437,
			"38": 0.004874,
			"39": 0.04874,
			"40": 0.009748,
			"41": 0.029244,
			"42": 0.002437,
			"43": 0.558073,
			"44": 0.065799,
			"45": 0.04874,
			"46": 0.095043,
			"47": 0.443534,
			"48": 0.370424,
			"49": 2.122627,
			"50": 0.355802,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.014622
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.077984,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.029244,
			"28": null,
			"29": 0.514207,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.187649,
			"34": 0.002437,
			"35": null,
			"36": null,
			"37": 0.087732,
			"38": 0.012185,
			"39": null,
			"40": 0.621435,
			"41": 0.04874,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.007311,
			"5": null,
			"6": 0.009748,
			"7": null,
			"8": 0.12185,
			"9": 0.056051,
			"10": 0.141346,
			"3.1": null,
			"3.2": 0.021933,
			"5.1": 0.075547,
			"6.1": 0.012185,
			"7.1": 0.017059,
			"9.1": 0.12185
		},
		"ios_saf": {
			"8": 0,
			"10": 1.57169341549,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0423553189009,
			"8.1-8.4": 0.0782496569525,
			"9.0-9.2": 0.0373301115737,
			"9.3": 0.569523497086
		},
		"android": {
			"3": 0,
			"4": 0.0841310465116,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.010516380814,
			"4.1": 0.303472703488,
			"4.2-4.3": 0.758681758721,
			"4.4": 1.73970985465,
			"4.4.3-4.4.4": 1.75473325581
		},
		"ie": {
			"6": 0.004874,
			"7": 0.004874,
			"8": 0.372861,
			"9": 0.126724,
			"10": 0.258322,
			"11": 4.352482,
			"5.5": null
		},
		"op_mob": {
			"0": 1.55269747453,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0431304854037
		},
		"edge": {
			"12": 0.082858,
			"13": 0.233952,
			"14": 0.058488
		},
		"ie_mob": {
			"10": 0.475723352113,
			"11": 1.93687364789
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 2.306715
		},
		"and_uc": {
			"0": 23.732694
		},
		"op_mini": {
			"0": 20.9192230401
		},
		"and_chr": {
			"0": 19.669896
		},
		"and_ff": {
			"0": 0.030252
		}
	},
	"total": 98.064032
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SB.json
 ** module id = 638
 ** module chunks = 0
 **/